import Type from './Type';
export function isIQuote(node) {
    return node.type === Type.Quote;
}
export default isIQuote;    //# sourceMappingURL=isIQuote.js.map
